import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { MEDIA_QUERIES, AccountService } from '@sm360/widget-commons-general';
import { LocaleService, ContentZonesService } from '@sm360/widget-commons-core-services';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';

import './TaxSavings.scss';
import TaxSavingsItem from './TaxSavingsItem/TaxSavingsItem.jsx';

function getHighValueColor() {
    const czGroup = 'widget.tradein.teaser';
    const highValueColorCz = ContentZonesService.getContentZone(czGroup, 'estimate.value.high.color');
    return highValueColorCz ? highValueColorCz.getValue() : 'inherit';
}

const TaxSavings = ({ tradeInValues }) => {
    const taxSavingsValue = Math.round(tradeInValues.amount * tradeInValues.taxesFactor);
    const totalSavingsValue = tradeInValues.amount + taxSavingsValue;

    const taxSavingsItemStyle = { fontSize: '20px' };
    taxSavingsItemStyle.color = getHighValueColor();

    return (
        <div className="TaxSavings__wrapper">
            <MediaQuery minWidth={MEDIA_QUERIES.MOBILE.MAX}>
                <div className="TaxSavingsItem__wrapper">
                    <TaxSavingsItem
                        content={{
                            label: LocaleService.t('TRADE_IN.TAX_SAVINGS.ESTIMATE'),
                            value: tradeInValues.amount,
                            iconStyles: ['icon-SetBudget'],
                        }}
                        dataTest="trade-in.tax-savings.estimate"
                    />
                    <span className="TaxSavings__divider">+</span>
                    <TaxSavingsItem
                        content={{
                            label: LocaleService.t('TRADE_IN.TAX_SAVINGS.TAX_SAVINGS'),
                            value: taxSavingsValue,
                            iconStyles: ['icon-Tax'],
                        }}
                        dataTest="trade-in.tax-savings.tax-saving"
                    />
                    <span className="TaxSavings__divider">=</span>
                    <TaxSavingsItem
                        content={{
                            label: LocaleService.t('TRADE_IN.TAX_SAVINGS.RESULT'),
                            value: totalSavingsValue,
                            iconStyles: ['icon-Thumb-up'],
                        }}
                        style={taxSavingsItemStyle}
                        dataTest="trade-in.tax-savings.final-price"
                    />
                </div>
            </MediaQuery>
            <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                <p className="is-centered is-light sr-disclaimer" data-test="trade-in.tax-savings.mobile">
                    {LocaleService.t('TRADE_IN.TAX_SAVINGS.MOBILE', {
                        estimate: LocaleService.l(tradeInValues.amount, CurrencyFormats.CURRENCY_0),
                        tax: LocaleService.l(taxSavingsValue, CurrencyFormats.CURRENCY_0),
                        total: LocaleService.l(totalSavingsValue, CurrencyFormats.CURRENCY_0),
                    })}
                </p>
            </MediaQuery>
            <div className="is-centered is-light sr-disclaimer">
                <p>
                    <icon className="icon-Warning is-warning" />
                    {!AccountService.isAuthenticated()
                        ? LocaleService.t('TRADE_IN.TAX_SAVINGS.LOGGED_OUT_DISCLAIMER')
                        : LocaleService.t('TRADE_IN.TAX_SAVINGS.LOGGED_IN_DISCLAIMER')}
                </p>
                <p>{LocaleService.t('TRADE_IN.TAX_SAVINGS.MAY_CONTACT_FOR_INFO')}</p>
            </div>
        </div>
    );
};

TaxSavings.propTypes = {
    tradeInValues: PropTypes.shape({
        amount: PropTypes.number.isRequired,
        high: PropTypes.number.isRequired,
        low: PropTypes.number.isRequired,
        taxesFactor: PropTypes.number.isRequired,
    }).isRequired,
};

TaxSavings.displayName = 'TaxSavings';

export default TaxSavings;



// WEBPACK FOOTER //
// ./src/components/EstimateTradeIn/components/TaxSavings/TaxSavings.jsx